import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const CircleCheck = forwardRef<SVGSVGElement, Partial<IconProps>>(function CircleCheck({
  styles,
  ...props
}, ref) {
  return <Icon styles={styles} viewBox="0 0 24 24" title="Check Mark" description="Check Mark" ref={ref} {...props}>
        <circle cx="12" cy="12" r="12" fillOpacity=".12" {...stylex.props([iconsStyles.greenElement])} />
        <path fillRule="evenodd" clipRule="evenodd" d="M19.5 7.09 9.531 18 4.5 13.181l1.221-1.17 3.726 3.57L18.2 6l1.3 1.09Z" {...stylex.props([iconsStyles.greenElement])} />
      </Icon>;
});